import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Dispatch} from "redux";
import Modal from "../general/modal";
import {
    isHideModalDataSelector,
    isShowModalDataSelector,
    modalDataSelector,
    modalNameSelector
} from "../../../store/selector/general";
import {general} from "../../../store/action";
import {useWrittenPrescriptionPrintOrder} from "../../../hook/request/ihioPrescriptionFilling";
import {TGIdNameData} from "../../../types/general";
import {IhioPrescriptionAdmissionType, IhioWrittenPrescriptionInfoType} from "../../../types/ihioPrescriptionFilling";
import {convertBase64ToFile, downloadFile} from "../../../utils/fileConvertor";
import {getAge} from "../../../utils/utils";
import {GENDER_ENUM} from "../../../constants/constant/enum";
import Icon from "../general/icon";

type ModalInfoProps = {
    writtenPrescriptionData?: IhioWrittenPrescriptionInfoType | null;
    prescriptionAdmissionData?: IhioPrescriptionAdmissionType;
}

type WrittenPrescriptionInfoModalProps = {
    modalData: any
    modalName: string;
    isShowModalData: boolean;
    handleHideModal: any;
    handleResetModal: any;
}

const WrittenPrescriptionInfoModal = ({
    modalData,
    modalName,
    isShowModalData,
    handleHideModal,
    handleResetModal,
}: WrittenPrescriptionInfoModalProps) => {

    const [showState, setShowState] = useState(false);
    const [modalInfo, setModalInfo] = useState<ModalInfoProps>({});

    const navigate = useNavigate();

    const writtenPrescriptionPrintOrderRequest = useWrittenPrescriptionPrintOrder()

    useEffect(() => {
        if(
            isShowModalData &&
            modalName === 'writtenPrescriptionInfoModal'
        ){
            setShowState(true);
            setModalInfo(modalData);
            handleResetModal();
        }
    }, [modalData, modalName])

    useEffect(() => {
        if(writtenPrescriptionPrintOrderRequest?.isSuccess && writtenPrescriptionPrintOrderRequest?.data?.data?.result && showState) {
            writtenPrescriptionPrintOrderRequest?.data?.data?.result?.map((item: any) => {
                handleDownloadIhioPrintPrescription(item?.file, item?.type)
            })
        }
    }, [writtenPrescriptionPrintOrderRequest?.data?.data?.result]);


    const handleDownloadIhioPrintPrescription = (base64Data: any, type: TGIdNameData) => {
        const file = convertBase64ToFile(
            base64Data,
            `نسخه ${type?.name} - ${modalInfo?.writtenPrescriptionData?.patient?.patient?.firstName} ${modalInfo?.writtenPrescriptionData?.patient?.patient?.lastName} - ${modalInfo?.writtenPrescriptionData?.creationDate}`,
            'application/pdf'
        )
        downloadFile(file);
    };

    const handleNavigate = () => {
        navigate('/prescriptionFilling/writtenPrescription', {state: {prescriptionAdmissionData: modalInfo.prescriptionAdmissionData, writtenPrescriptionData: modalInfo.writtenPrescriptionData}})
    }


    const handleSetShowModal = () => {
        setShowState(false);
        handleHideModal();
    }

    return (
        <Modal
            setShow={handleSetShowModal}
            showState={showState}
            noCloseBtn={true}
            className="w-1000 mw-100"
            bodyClassName="py-5 px-3 px-lg-5 pos-rel"
        >
            <div className='d-flex mb-4 fs-3 px-2'>
                <div className=" px-2 flex-fill align-content-center">
                    <h4 className="d-flex align-items-center title-dot font-16 font-weight-bold">
                        اطلاعات نسخه
                    </h4>
                </div>
                <span className='text-red-hover align-content-center mt-2' onClick={() => handleSetShowModal()}>
                      <Icon name='close-square'/>
                    </span>
            </div>
            <div className={'row row-cols-md-2 row-cols-1 gap-2 h-100'}>
                <div className={'row row-cols-1 row-cols-md-2 h-100'}>
                    <div
                        className={'card align-items-center justify-content-between shadow-none border border-gray-500 h-100 w-100 p-3 px-8'}>
                        <div
                            className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                <span className='fs-6 text-gray-800 fw-bold '>
                                    {((modalInfo?.writtenPrescriptionData?.patient?.patient?.firstName && modalInfo?.writtenPrescriptionData?.patient?.patient?.lastName) && modalInfo?.writtenPrescriptionData?.patient?.patient?.firstName + ' ' + modalInfo?.writtenPrescriptionData?.patient?.patient?.lastName) || '- - -'}
                                </span>
                            <span className='fs-7 text-gray-500 fw-bold'>
                                    {modalInfo?.writtenPrescriptionData?.patient?.patient?.nationalCode || ''}
                                </span>
                        </div>
                        <div className={'w-100 row row-cols-md-2 row-cols-1'}>
                            <div className={' '}>
                                <div
                                    className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                        <span className='fs-6 text-gray-800 fw-bold '>
                                            جنسیت:
                                        </span>
                                    <span className='fs-7 text-gray-500 fw-bold'>
                                            {modalInfo?.writtenPrescriptionData?.patient?.patient?.gender?.id ? (modalInfo?.writtenPrescriptionData?.patient?.patient?.gender?.name || GENDER_ENUM?.find((gender: any) => gender?.value === modalInfo?.writtenPrescriptionData?.patient?.patient?.gender?.id)?.label) : '-'}
                                        </span>
                                </div>
                            </div>
                            <div className={''}>
                                <div
                                    className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                        <span className='fs-6 text-gray-800 fw-bold '>
                                            سن:
                                        </span>
                                    <span className='fs-7 text-gray-500 fw-bold'>
                                            {modalInfo?.writtenPrescriptionData?.patient?.patient?.birthDate ? getAge(modalInfo?.writtenPrescriptionData?.patient?.patient?.birthDate) : '- - -'}
                                        </span>
                                </div>
                            </div>
                        </div>
                        <div className={'w-100 row row-cols-2'}>
                            <div className={' '}>
                                <div
                                    className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                        <span className='fs-6 text-gray-800 fw-bold '>
                                            وضعیت تاهل:
                                        </span>
                                    <span className='fs-7 text-gray-500 fw-bold'>
                                            {/*{modalInfo?.writtenPrescriptionData?.patient?.patient?.maritalStatus ? modalInfo?.writtenPrescriptionData?.patient?.patient?.maritalStatus?.name : '- - -'}*/}
                                        </span>
                                </div>
                            </div>
                            <div className={' '}>
                                <div
                                    className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                        <span className='fs-6 text-gray-800 fw-bold '>
                                            شماره موبایل:
                                        </span>
                                    <span className='fs-7 text-gray-500 fw-bold'>
                                            {modalInfo?.writtenPrescriptionData?.patient?.patient?.mobile ? modalInfo?.writtenPrescriptionData?.patient?.patient?.mobile : '- - -'}
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'row row-cols-1 row-cols-md-2'}>
                    <div className={'w-100 row row-cols-2'}>
                        <div className={''}>
                            <div
                                className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                    <span className='fs-6 text-gray-800 fw-bold '>
                                        نام همکار:
                                    </span>
                                <span className='fs-7 text-gray-500 fw-bold'>
                                        {modalInfo?.writtenPrescriptionData?.providerName ? modalInfo?.writtenPrescriptionData?.providerName : '- - -'}
                                    </span>
                            </div>
                        </div>
                        <div className={' '}>
                            <div
                                className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                    <span className='fs-6 text-gray-800 fw-bold '>
                                        نام شریک کاری:
                                    </span>
                                <span className='fs-7 text-gray-500 fw-bold'>
                                        {modalInfo?.writtenPrescriptionData?.partnerName ? modalInfo?.writtenPrescriptionData?.partnerName : '- - -'}
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div className={'w-100 row row-cols-2'}>
                        <div className={' '}>
                            <div
                                className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                    <span className='fs-6 text-gray-800 fw-bold '>
                                        تخصص:
                                    </span>
                                <span className='fs-7 text-gray-500 fw-bold'>
                                        {modalInfo?.writtenPrescriptionData?.providerSpecialty ? modalInfo?.writtenPrescriptionData?.providerSpecialty : '- - -'}
                                    </span>
                            </div>
                        </div>
                        <div className={' '}>
                            <div
                                className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                    <span className='fs-6 text-gray-800 fw-bold '>
                                        کد نظام پزشکی:
                                    </span>
                                <span className='fs-7 text-gray-500 fw-bold'>
                                        {modalInfo?.writtenPrescriptionData?.irimcCode ? modalInfo?.writtenPrescriptionData?.irimcCode : '- - -'}
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div className={'w-100 row row-cols-2'}>
                        <div className={' '}>
                            <div
                                className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                    <span className='fs-6 text-gray-800 fw-bold '>
                                        کد رهگیری:
                                    </span>
                                <span className='fs-7 text-gray-500 fw-bold'>
                                        {modalInfo?.prescriptionAdmissionData?.trackingCode ? modalInfo?.prescriptionAdmissionData?.trackingCode : '- - -'}
                                    </span>
                            </div>
                        </div>
                        <div className={' '}>
                            <div
                                className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                                    <span className='fs-6 text-gray-800 fw-bold '>
                                        تعداد خدمت در نسخه:
                                    </span>
                                <span className='fs-7 text-gray-500 fw-bold'>
                                        {modalInfo?.writtenPrescriptionData?.items ? `${modalInfo?.writtenPrescriptionData?.items?.length} عدد` : '- - -'}
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div
                        className='card align-items-center justify-content-center w-100 shadow-none border-2 border-dashed p-2 my-2'>
                            <span className='fs-6 text-gray-800 fw-bold '>
                                کد سماد:
                            </span>
                        <span className='fs-7 text-gray-500 fw-bold'>
                                {modalInfo?.writtenPrescriptionData?.samadCode ? modalInfo?.writtenPrescriptionData?.samadCode : '- - -'}
                            </span>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center mt-4 pt-2">
                <button
                    onClick={() => handleSetShowModal()}
                    className="btn btn-outline-gray flex-grow-1 py-2 mx-1"
                >
                    انصراف
                </button>
                <button
                    onClick={() => writtenPrescriptionPrintOrderRequest.mutate(modalInfo?.prescriptionAdmissionData)}
                    className="btn btn-navy-blue flex-grow-1 py-2 mx-1"
                >
                    چاپ نسخه
                </button>
                <button
                    onClick={() => handleNavigate()}
                    className="btn btn-primary flex-grow-1 py-2 mx-1"
                >
                    ارائه خدمت
                </button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state: any) => ({
    modalData: modalDataSelector(state),
    modalName: modalNameSelector(state),
    isShowModalData: isShowModalDataSelector(state),
    isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleHideModal: () => dispatch(general.handleHideModal()),
    handleResetModal: () => dispatch(general.handleResetModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WrittenPrescriptionInfoModal);
